export default "__VITE_ASSET__DUGe1X7n__"